import ActivateArticlesPage from './pages/ActivateArticlesPage';
import LoginPage from './pages/LoginPage';
import MenuPage from './pages/MenuPage';
import WorkpostsmenuPage from './pages/WorkpostsmenuPage';
import InputPage from './pages/InputPage';
import ProductOverviewPage from './pages/ProductOverviewPage';
import ProductpagePage from './pages/ProductpagePage';
import ProductgrouppagePage from './pages/ProductgrouppagePage';
import EditproductgroupPage from './pages/EditproductgroupPage';
import ProfilepagePage from './pages/ProfilepagePage';
import OptimizedpaintlistviewPage from './pages/OptimizedpaintlistviewPage';
import PaintlistlinePage from './pages/PaintlistlinePage';
import PaintlistcreatePage from './pages/PaintlistcreatePage';
import PaintlisteditlinePage from './pages/PaintlisteditlinePage';
import OrderpagePage from './pages/OrderpagePage';
import PausePage from './pages/PausePage';
import TimePage from './pages/TimePage';
import CopyserviceorderproductPage from './pages/CopyserviceorderproductPage';
import EditProducttypePage from './pages/EditProducttypePage';
import EditproductPage from './pages/EditproductPage';
import PaintlistformPage from './pages/PaintlistformPage';
import PaintworkformdetailsPage from './pages/PaintworkformdetailsPage';
import PaintworkFormPage from './pages/PaintworkFormPage';
import InputralPage from './pages/InputralPage';
import ColoroverviewPage from './pages/ColoroverviewPage';
import CanvasOverviewPage from './pages/CanvasOverviewPage';
import InputprofilePage from './pages/InputprofilePage';
import InputworkhourPage from './pages/InputworkhourPage';
import EditcolorpagePage from './pages/EditcolorpagePage';
import ColorpagePage from './pages/ColorpagePage';
import EditCanvasPage from './pages/EditCanvasPage';
import CanvasPage from './pages/CanvasPage';
import SyncPage from './pages/SyncPage';
import StockcountPage from './pages/StockcountPage';
import StockcounttabletPage from './pages/StockcounttabletPage';
import SearchprofilePage from './pages/SearchprofilePage';
import CreatepaintworkformPage from './pages/CreatepaintworkformPage';
import ProductinfoPage from './pages/ProductinfoPage';
import ProductdetailsPage from './pages/ProductdetailsPage';
import ProductsawPage from './pages/ProductsawPage';
import ProductlabelsPage from './pages/ProductlabelsPage';
import ProductlistdetailsPage from './pages/ProductlistdetailsPage';
import PaintlistforproductPage from './pages/PaintlistforproductPage';
import PaintlistforcolorPage from './pages/PaintlistforcolorPage';
import PartslistviewPage from './pages/PartslistviewPage';
import PartslisteditPage from './pages/PartslisteditPage';
import PartslisteditlinePage from './pages/PartslisteditlinePage';
import BatchPage from './pages/BatchPage';
import BatchpaintlistPage from './pages/BatchpaintlistPage';
import ProducthistoryPage from './pages/ProducthistoryPage';
import EditprofilepagePage from './pages/EditprofilepagePage';
import ProductgroupdetailsPage from './pages/ProductgroupdetailsPage';
import NewordersPage from './pages/NewordersPage';
import QuotationsPage from './pages/QuotationsPage';
import LabeldeurPage from './pages/LabeldeurPage';
import LabelsmallraamPage from './pages/LabelsmallraamPage';
import LabelretourPage from './pages/LabelretourPage';
import EmployeesPage from './pages/EmployeesPage';
import LeaveschedulePage from './pages/LeaveschedulePage';
import SettingsPage from './pages/SettingsPage';
import MaterialTypesSettingsOverviewPage from './pages/MaterialTypesSettingsOverviewPage';
import MaterialTypesSettingsDetailPage from './pages/MaterialTypesSettingsDetailPage';
import SettingsProducttypesPage from './pages/SettingsProducttypesPage';
import SettingsProfileInfoPage from './pages/SettingsProfileInfoPage';
import EditProfileGroupPage from './pages/EditProfileGroupPage';
import SettingsSchedulePage from './pages/SettingsSchedulePage';
import EditProductionInfoPage from './pages/EditProductionInfoPage';
import SchedulePage from './pages/SchedulePage';
import EditpasswordemployeePage from './pages/EditpasswordemployeePage';
import EmployeedetailsPage from './pages/EmployeedetailsPage';
import EmployeeperformancePage from './pages/EmployeeperformancePage';
import EmployeeleavePage from './pages/EmployeeleavePage';
import EmployeeworkhoursPage from './pages/EmployeeworkhoursPage';
import WorkweekPage from './pages/WorkweekPage';
import LeavegeneralPage from './pages/LeavegeneralPage';
import StatisticsPage from './pages/StatisticsPage';
import ExportProductsPage from './pages/ExportProductsPage';
import DebugmenuPage from './pages/DebugmenuPage';
import DebugcncPage from './pages/DebugcncPage';
import AddorderlinePage from './pages/AddorderlinePage';
import OrderlineoverviewPage from './pages/OrderlineoverviewPage';
import PrinttextlabelPage from './pages/PrinttextlabelPage';
import DeliverydateoverviewPage from './pages/DeliverydateoverviewPage';
import DeliveryDateDetailsPage from './pages/DeliveryDateDetailsPage';
import DeliveryRoutesPage from './pages/DeliveryRoutesPage';
import DeliveryRouteDetailsPage from './pages/DeliveryRouteDetailsPage';
import AddDeliveryRoutePage from './pages/AddDeliveryRoutePage';
import EditDeliveryRoutePage from './pages/EditDeliveryRoutePage';
import EditdeliverydatePage from './pages/EditdeliverydatePage';
import PowderOverviewPage from './pages/PowderOverviewPage';
import EmployeeabsencePage from './pages/EmployeeabsencePage';
import SemifinishedproductoverviewPage from './pages/SemifinishedproductoverviewPage';
import SemifinishedproductdeliveroverviewPage from './pages/SemifinishedproductdeliveroverviewPage';
import DevtoolsPage from './pages/DevtoolsPage';
import ProcesspaintlistsPage from './pages/ProcesspaintlistsPage';
import AddloonlakwerkpagePage from './pages/AddloonlakwerkpagePage';
import SawmachinePage from './pages/SawmachinePage';
import CncPage from './pages/CncPage';
import DebugsawlinesPage from './pages/DebugsawlinesPage';
import CuttingandpleatingPage from './pages/CuttingandpleatingPage';
import ValidateCuttingPleatingOverviewPage from './pages/ValidateCuttingPleatingOverviewPage';
import ValidateCuttingPleatingDetailPage from './pages/ValidateCuttingPleatingDetailPage';
import ValidateProductsPage from './pages/ValidateProductsPage';
import GlassproductsPage from './pages/GlassproductsPage';
import ServicesPage from './pages/ServicesPage';
import DebugsawlineerrorsPage from './pages/DebugsawlineerrorsPage';
import DebugactivateprofilePage from './pages/DebugactivateprofilePage';
import PleatingoverviewPage from './pages/PleatingoverviewPage';
import PleatinglistoverviewPage from './pages/PleatinglistoverviewPage';
import PleatinglistdetailsPage from './pages/PleatinglistdetailsPage';
import WorkpostcuttingPage from './pages/WorkpostcuttingPage';
import WorkpostPleatingPage from './pages/WorkpostPleatingPage';
import WorkpostLaserPage from './pages/WorkpostLaserPage';
import ProductionprogressPage from './pages/ProductionprogressPage';
import SetttingsworkstationtypesPage from './pages/SetttingsworkstationtypesPage';
import FormworkstationtypesPage from './pages/FormworkstationtypesPage';
import ProductEditOverviewPage from './pages/ProductEditOverviewPage';
import PaintlistpaintshopPage from './pages/PaintlistpaintshopPage';
import WorkpostPaintScreenPage from './pages/WorkpostPaintScreenPage';
import ProductTypeDetailsPage from './pages/ProductTypeDetailsPage';
import DebugProductDescriptionsPage from './pages/DebugProductDescriptionsPage';
import AddWorkstationPage from './pages/AddWorkstationPage';
import EditWorkstationPage from './pages/EditWorkstationPage';
import WorkpostScanProductsPage from './pages/WorkpostScanProductsPage';
import ProducttypeSawlineDetailsPage from './pages/ProducttypeSawlineDetailsPage';
import ProductTypeSawlineEditPage from './pages/ProductTypeSawlineEditPage';
import ProductOverviewWorkpostPage from './pages/ProductOverviewWorkpostPage';
import TestAutoComplete from './pages/TestAutoComplete';
import InputStockArticlesPage from './pages/InputStockArticlesPage';
import SettingsArticlesPage from './pages/SettingsArticlesPage';
import SettingsStockLocationsPage from './pages/SettingsStockLocationsPage';
import AddStockLocationPage from './pages/AddStockLocationPage';
import WorkstationLocationPage from './pages/WorkstationLocationPage';
import TimelinePage from './pages/TimelinePage';
import PartslistlinePage from './pages/PartslistlinePage';
import EditWorkstationScreenPage from './pages/EditWorkstationScreenPage';
import WorkstationProfilesOn from './pages/WorkstationProfilesOn';
import WorkstationProfilesOff from './pages/WorkstationProfilesOff';
import WorkstationProfilesPrep from './pages/WorkstationProfilesPrep';
import AppSettingsPage from './pages/AppSettingsPage';
import DashboardPage from './pages/DashboardPage';
import ErrorsPage from './pages/ErrorsPage';
import CanvasWorkOverviewPage from './pages/CanvasWorkOverviewPage';
import OptimizedCanvasListsPage from './pages/OptimizedCanvasListsPage';
import OptimizedProductlistdetailsPage from './pages/OptimizedProductlistdetailsPage';
import ProductTypeGroupsPage from './pages/ProductTypeGroupsPage';
import InteractiveProductFlowsPage from './pages/InteractiveProductFlowsPage.vue';
import SettingsPrintersPage from './pages/SettingsPrintersPage';

export const routes = [
    {
        path: '/',
        redirect: '/menu',
    },
    {
        title: 'Eosol ERP',
        path: '/login',
        component: LoginPage,
    },
    {
        title: 'Startpagina',
        path: '/menu',
        component: MenuPage,
    },
    {
        title: 'Werkposten',
        path: '/workpostsmenu',
        component: WorkpostsmenuPage,
    },
    {
        title: 'Invoeren bestellingen',
        path: '/input',
        component: InputPage,
    },
    {
        title: 'Overzicht producten',
        path: '/productoverview',
        component: ProductOverviewPage,
    },
    {
        title: 'Producten',
        path: '/workstation/:id',
        component: ProductOverviewWorkpostPage,
    },
    {
        title: '&nbsp;',
        path: '/productpage/:id',
        component: ProductpagePage,
    },
    {
        title: '<span id="productgrouppagenr">&nbsp;</span>',
        path: '/productgrouppage/:id',
        component: ProductgrouppagePage,
    },
    {
        title: 'Productgroep wijzigen',
        path: '/editproductgroup/:id',
        component: EditproductgroupPage,
    },
    {
        title: 'Profiel',
        path: '/profilepage/:id',
        component: ProfilepagePage,
    },
    {
        title: 'Lakbon nr',
        path: '/optimizedpaintlistview/:id',
        component: OptimizedpaintlistviewPage,
    },
    {
        title: 'Lakbonlijn nr',
        path: '/paintlistline/:id/:recordId',
        component: PaintlistlinePage,
    },
    {
        title: 'Lakbonlijn nr <span id="productpaintlistcreatenr"></span> bijwerken',
        path: '/paintlisteditline/:productId/:paintlistId/:recordId',
        component: PaintlisteditlinePage,
    },
    {
        title: 'Nieuwe lakbonlijn voor <span id="productpaintlistcreatenr"></span>',
        path: '/paintlistcreateline/:productId/:paintlistId',
        component: PaintlisteditlinePage,
    },
    {
        title: '&nbsp;',
        path: '/paintlistcreate/:productId/:paintlistId',
        component: PaintlistcreatePage,
    },
    {
        title: 'Bestelling',
        path: '/orderpage/:id',
        component: OrderpagePage,
    },
    {
        title: 'Pauze voor tijdsregistratie bij verplaatsing',
        path: '/pause',
        component: PausePage,
    },
    {
        title: 'Tijdsregistratie',
        path: '/time',
        component: TimePage,
    },
    {
        title: 'Nieuw product op basis van <span id="productName"></span>',
        path: '/copyserviceorderproduct',
        component: CopyserviceorderproductPage,
    },
    {
        title: '&nbsp;',
        path: '/addProductType',
        component: EditProducttypePage,
    },
    {
        title: '&nbsp;',
        path: '/editProducttype/:id',
        component: EditProducttypePage,
    },
    {
        title: 'Product',
        path: '/editproduct',
        component: EditproductPage,
    },
    {
        title: 'Lakbonnen - Overzicht',
        path: '/paintlistform',
        component: PaintlistformPage,
    },
    {
        title: 'Details lakwerkorder',
        path: '/paintworkformdetails/:id',
        component: PaintworkformdetailsPage,
    },
    {
        title: 'Lakwerkorder - Overzicht',
        path: '/paintworkform',
        component: PaintworkFormPage,
    },
    {
        title: 'Invoeren kleuren',
        path: '/inputral',
        component: InputralPage,
    },
    {
        title: 'Invoeren profielen',
        path: '/inputprofile',
        component: InputprofilePage,
    },
    {
        title: 'Invoeren werkuren',
        path: '/inputworkhour',
        component: InputworkhourPage,
    },
    {
        title: 'Overzicht kleuren',
        path: '/coloroverview',
        component: ColoroverviewPage,
    },
    {
        title: 'Kleur',
        path: '/editcolorpage/:id',
        component: EditcolorpagePage,
    },
    {
        title: 'Kleur',
        path: '/colorpage/:id',
        component: ColorpagePage,
    },
    {
        title: 'Synchronisatie <span id="inputOrderId"></span>',
        path: '/sync',
        component: SyncPage,
    },
    {
        title: 'Stocktelling van <span id="stockcountdate"></span>',
        path: '/stockcount',
        component: StockcountPage,
    },
    {
        title: 'Stocktellingen',
        path: '/stockcounttablet',
        component: StockcounttabletPage,
    },
    {
        title: 'Zoek profielen',
        path: '/searchprofile',
        component: SearchprofilePage,
    },
    {
        title: 'Aanmaken lakwerkorder',
        path: '/createpaintworkform',
        component: CreatepaintworkformPage,
    },
    {
        title: 'Kleur toevoegen',
        path: '/addcolorpage',
        component: EditcolorpagePage,
    },
    {
        title: 'Extra info bij product <span id="productinfoproductid"></span>',
        path: '/productinfo/:id',
        component: ProductinfoPage,
    },
    {
        title: 'Product - Productiebon',
        path: '/productdetails/:id',
        component: ProductdetailsPage,
    },
    {
        title: 'Product - Zaaglijst',
        path: '/productsaw/:id',
        component: ProductsawPage,
    },
    {
        title: 'Etiketten voor product',
        path: '/productlabels/:id',
        component: ProductlabelsPage,
    },
    {
        title: 'Lakbon voor product',
        path: '/paintlistforproduct',
        component: PaintlistforproductPage,
    },
    {
        title: 'Lakbon voor kleur',
        path: '/paintlistforcolor',
        component: PaintlistforcolorPage,
    },
    {
        title: 'Stuklijst',
        path: '/partslistview/:productId/:partslistId',
        component: PartslistviewPage,
    },
    {
        title: 'Bewerk stuklijst',
        path: '/partslistedit/:productId/:partslistId',
        component: PartslisteditPage,
    },
    {
        title: 'Stuklijstlijn',
        path: '/partslistline/:productId/:partslistId/:partslistLineId',
        component: PartslistlinePage,
    },
    {
        title: 'Bewerk stuklijstlijn',
        path: '/partslisteditline/:productId/:partslistId/:partslistLineId',
        component: PartslisteditlinePage,
    },
    {
        title: 'Nieuwe stuklijstlijn voor stuklijst',
        path: '/partslistcreateline/:productId/:partslistId',
        component: PartslisteditlinePage,
    },
    {
        title: 'Batchverwerking producten',
        path: '/batch',
        component: BatchPage,
    },
    {
        title: 'Batchverwerking lakbonnen',
        path: '/batchpaintlist',
        component: BatchpaintlistPage,
    },
    {
        title: 'Product - Geschiedenis',
        path: '/producthistory/:id',
        component: ProducthistoryPage,
    },
    {
        title: 'Nieuw profiel toevoegen',
        path: '/addprofilepage',
        component: EditprofilepagePage,
    },
    {
        title: 'Profiel <span id="editprofilepagenr"></span>',
        path: '/editprofilepage/:id',
        component: EditprofilepagePage,
    },
    {
        title: 'Nieuw profiel toevoegen',
        path: '/copyprofilepage',
        component: EditprofilepagePage,
    },
    {
        title: 'Productgroep - Productiebon',
        path: '/productgroupdetails/:id',
        component: ProductgroupdetailsPage,
    },
    {
        title: 'Nieuwe bestellingen',
        path: '/neworders',
        component: NewordersPage,
    },
    {
        title: 'Prijsaanvragen',
        path: '/quotations',
        component: QuotationsPage,
    },
    {
        title: '',
        path: '/labeldeur/:id',
        component: LabeldeurPage,
    },
    {
        title: '',
        path: '/labelsmallraam/:id',
        component: LabelsmallraamPage,
    },
    {
        title: '',
        path: '/labelretour/:id',
        component: LabelretourPage,
    },
    {
        title: 'Overzicht werknemers',
        path: '/employees',
        component: EmployeesPage,
    },
    {
        title: '',
        path: '/leaveschedule',
        component: LeaveschedulePage,
    },
    {
        title: 'Instellingen',
        path: '/settings',
        component: SettingsPage,
    },
    {
        title: 'Applicatie-instellingen',
        path: '/appsettings',
        component: AppSettingsPage,
    },
    {
        title: 'Producttypes',
        path: '/settingsProducttypes',
        component: SettingsProducttypesPage,
        skipProductTypeCache: true,
    },
    {
        title: '',
        path: '/settingsProfile',
        component: SettingsProfileInfoPage,
    },
    {
        title: 'Bewerk profielgroep',
        path: '/editProfileGroup/:id',
        component: EditProfileGroupPage,
    },
    {
        title: 'Nieuwe profielgroep',
        path: '/addProfileGroup/:level',
        component: EditProfileGroupPage,
    },
    {
        title: 'Parameters',
        path: '/settingsSchedule',
        component: SettingsSchedulePage,
    },
    {
        title: 'Productie-informatie',
        path: '/editProductionInfo/:id',
        component: EditProductionInfoPage,
    },
    {
        title: '',
        path: '/schedule',
        component: SchedulePage,
    },
    {
        title: 'Wachtwoord wijzigen',
        path: '/editpasswordemployee/:id',
        component: EditpasswordemployeePage,
    },
    {
        title: '&nbsp;',
        path: '/employeedetails/:id',
        component: EmployeedetailsPage,
    },
    {
        title: 'Prestaties',
        path: '/employeeperformance/:id',
        component: EmployeeperformancePage,
    },
    {
        title: 'Verlofdagen',
        path: '/employeeleave/:id',
        component: EmployeeleavePage,
    },
    {
        title: 'Overzicht werknemers',
        path: '/employeeworkhours',
        component: EmployeeworkhoursPage,
    },
    {
        title: 'Werkweek beheren',
        path: '/workweek',
        component: WorkweekPage,
    },
    {
        title: 'Algemene verlofdagen voor <span class="selectedYear"></span>',
        path: '/leavegeneral',
        component: LeavegeneralPage,
    },
    {
        title: 'Statistieken',
        path: '/statistics',
        component: StatisticsPage,
    },
    {
        title: 'Exporteer Producten',
        path: '/export-products',
        component: ExportProductsPage,
    },
    {
        title: 'Debug',
        path: '/debugmenu',
        component: DebugmenuPage,
    },
    {
        title: 'Debug CNC Test',
        path: '/debugcnc',
        component: DebugcncPage,
    },
    {
        title: 'Nieuwe orderlijn toevoegen',
        path: '/addorderline',
        component: AddorderlinePage,
        name: 'addorderline',
    },
    {
        title: 'Overzicht bestellijnen',
        path: '/orderlineoverview',
        component: OrderlineoverviewPage,
    },
    {
        title: 'Etiket met vrije tekst',
        path: '/printtextlabel',
        component: PrinttextlabelPage,
    },
    {
        title: 'Overzicht ritten',
        path: '/deliverydates',
        component: DeliverydateoverviewPage,
    },
    {
        title: 'Overzicht klanten voor rit',
        path: '/deliverydatedetails/:id',
        component: DeliveryDateDetailsPage,
    },
    {
        title: 'Overzicht rondes',
        path: '/deliveryroutes',
        component: DeliveryRoutesPage,
    },
    {
        title: 'Overzicht klanten voor ronde',
        path: '/deliveryroutesdetails/:id',
        component: DeliveryRouteDetailsPage,
    },
    {
        title: 'Ronde toevoegen',
        path: '/adddeliveryroute',
        component: AddDeliveryRoutePage,
    },
    {
        title: 'Ronde',
        path: '/editdeliveryroute/:id',
        component: EditDeliveryRoutePage,
    },
    {
        title: 'Rit toevoegen',
        path: '/adddeliverydate',
        component: EditdeliverydatePage,
    },
    {
        title: 'Rit aanpassen',
        path: '/editdeliverydate/:id',
        component: EditdeliverydatePage,
    },
    {
        title: 'Overzicht te bestellen poeders',
        path: '/powderoverview',
        component: PowderOverviewPage,
    },
    {
        title: 'Afwezigheden',
        path: '/employeeabsence/:id',
        component: EmployeeabsencePage,
    },
    {
        title: 'Overzicht te bestellen half fabrikaten',
        path: '/semifinishedproductoverview',
        component: SemifinishedproductoverviewPage,
    },
    {
        title: 'Overzicht te leveren half fabrikaten en producten',
        path: '/semifinishedproductdeliveroverview',
        component: SemifinishedproductdeliveroverviewPage,
    },
    {
        title: 'Ontwikkelingsomgeving',
        path: '/devtools',
        component: DevtoolsPage,
    },
    {
        title: 'Lakbonnen verwerken',
        path: '/processpaintlistoverview',
        component: ProcesspaintlistsPage,
    },
    {
        title: 'Nieuw loonlakwerk toevoegen',
        path: '/addloonlakwerkpage',
        component: AddloonlakwerkpagePage,
    },
    {
        title: 'Zaagmachine',
        path: '/sawmachine',
        component: SawmachinePage,
    },
    {
        title: 'WP Oprekken',
        path: '/workstationprofileson',
        component: WorkstationProfilesOn,
    },
    {
        title: 'WP Afrekken',
        path: '/workstationprofilesoff',
        component: WorkstationProfilesOff,
    },
    {
        title: 'WP Dompelen',
        path: '/workstationprofilesprep',
        component: WorkstationProfilesPrep,
    },
    {
        title: 'Werkpost CNC',
        path: '/workpostcnc',
        component: CncPage,
        disableScroll: true,
    },
    {
        title: 'Debug zaaglijnen',
        path: '/debugsawlines',
        component: DebugsawlinesPage,
    },
    {
        title: 'Validatie Knip- en plooiwerk',
        path: '/cuttingandpleating',
        component: CuttingandpleatingPage,
    },
    {
        title: 'Validatie Knip- en plooiwerk',
        path: '/validate-cutting-pleating',
        component: ValidateCuttingPleatingOverviewPage,
    },
    {
        title: 'Validatie Knip- en plooiwerk',
        path: '/validate-cutting-pleating/:id',
        component: ValidateCuttingPleatingDetailPage,
    },
    {
        title: 'Andere Producten met status IV',
        path: '/validateproducts',
        component: ValidateProductsPage,
    },
    {
        title: 'Outdoor Glass',
        path: '/glassproducts',
        component: GlassproductsPage,
    },
    {
        title: 'Services',
        path: '/services',
        component: ServicesPage,
    },
    {
        title: 'Fouten zaaglijnen',
        path: '/debugsawlineerrors',
        component: DebugsawlineerrorsPage,
    },
    {
        title: 'Activeer profiel',
        path: '/debugactivateprofile',
        component: DebugactivateprofilePage,
    },
    {
        title: 'Overzicht plooiwerk',
        path: '/pleatingworkoverview',
        component: PleatingoverviewPage,
    },
    {
        title: 'Plooibonnen',
        path: '/pleatinglistoverview',
        component: PleatinglistoverviewPage,
    },
    {
        title: 'Plooibon',
        path: '/pleatinglistdetails/:id',
        component: PleatinglistdetailsPage,
    },
    {
        title: 'WP Knippen',
        path: '/workpostcutting',
        component: WorkpostcuttingPage,
    },
    {
        title: 'WP Plooien',
        path: '/workpostpleating',
        component: WorkpostPleatingPage,
    },
    {
        title: 'WP Laser',
        path: '/workpostlaser',
        component: WorkpostLaserPage,
    },
    {
        title: 'Productievoortgang',
        path: '/productionprogress',
        component: ProductionprogressPage,
    },
    {
        title: 'Werkposten',
        path: '/settingsworkstationtypes',
        component: SetttingsworkstationtypesPage,
    },
    {
        title: 'Werkposttype toevoegen',
        path: '/addworkstationtype',
        component: FormworkstationtypesPage,
    },
    {
        title: 'Werkposttype bijwerken',
        path: '/editworkstationtype/:id',
        component: FormworkstationtypesPage,
    },
    {
        title: 'Bewerken producten',
        path: '/producteditoverview',
        component: ProductEditOverviewPage,
    },
    {
        title: 'WP Poedercabine',
        path: '/paintlistpaintshop',
        component: PaintlistpaintshopPage,
    },
    {
        title: 'WP Poedercabine',
        path: '/work-post-paint-screen',
        component: WorkpostPaintScreenPage,
    },
    {
        title: 'Details producttype',
        path: '/producttypeDetails/:id',
        component: ProductTypeDetailsPage,
    },
    {
        title: 'Debug productbeschrijvingen',
        path: '/debugproductdescriptions',
        component: DebugProductDescriptionsPage,
    },
    {
        title: 'Werkpost toevoegen',
        path: '/addworkstation',
        component: AddWorkstationPage,
    },
    {
        title: 'Werkpost bijwerken',
        path: '/editworkstation/:id',
        component: EditWorkstationPage,
    },
    {
        title: 'Werkpostscherm toevoegen',
        path: '/addworkstationscreen',
        component: EditWorkstationScreenPage,
    },
    {
        title: 'Werkpostscherm bijwerken',
        path: '/editworkstationscreen/:id',
        component: EditWorkstationScreenPage,
    },
    {
        title: 'Tikklok producten',
        path: '/workpostscanproduct/:id',
        component: WorkpostScanProductsPage,
        disableScroll: true,
    },
    {
        title: 'Zaaglijnen bekijken',
        path: '/producttypesawlines/:id',
        component: ProducttypeSawlineDetailsPage,
    },
    {
        title: 'Zaaglijnen aanpassen',
        path: '/producttypesawlinesedit/:id',
        component: ProductTypeSawlineEditPage,
    },
    {
        title: 'Test autocomplete',
        path: '/test-autocomplete/:id',
        component: TestAutoComplete,
    },
    {
        title: 'Afbeeldingen stockartikelen',
        path: '/inputstockarticlesimages',
        component: InputStockArticlesPage,
    },
    {
        title: 'Prefixen artikelen',
        path: '/settingsarticles',
        component: SettingsArticlesPage,
    },
    {
        title: 'Stocklocaties',
        path: '/settingsstocklocations',
        component: SettingsStockLocationsPage,
    },
    {
        title: 'Printers',
        path: '/settingsprinters',
        component: SettingsPrintersPage,
    },
    {
        title: 'Stocklocatie toevoegen',
        path: '/addstocklocation',
        component: AddStockLocationPage,
    },
    {
        title: 'WP Locatie',
        path: '/workstationlocation',
        component: WorkstationLocationPage,
    },
    {
        title: 'Tijdlijn werknemer',
        path: '/timeline/:id',
        component: TimelinePage,
    },
    {
        title: 'Meerdere artikelen heractiveren',
        path: '/activatearticles',
        component: ActivateArticlesPage,
    },
    {
        title: 'Dashboard',
        path: '/dashboard',
        component: DashboardPage,
    },
    {
        title: 'Fouten',
        path: '/errors',
        component: ErrorsPage,
    },
    {
        title: 'Overzicht doeken', // generic non-optimized lists
        path: '/canvasworkoverview',
        component: CanvasWorkOverviewPage,
    },
    {
        title: 'Doekbonnen',
        path: '/optimizedcanvaslists',
        component: OptimizedCanvasListsPage,
    },
    {
        title: 'Overzicht doeken',
        path: '/canvasoverview',
        component: CanvasOverviewPage,
    },
    {
        title: 'Doek',
        path: '/editcanvaspage/:id',
        component: EditCanvasPage,
    },
    {
        title: 'Doek',
        path: '/canvaspage/:id',
        component: CanvasPage,
    },
    {
        title: 'Doek toevoegen',
        path: '/addcanvaspage',
        component: EditCanvasPage,
    },
    {
        title: 'Bondetails',
        path: '/productlistdetails/:id',
        component: ProductlistdetailsPage,
    },
    {
        title: 'Bondetails',
        path: '/optimizedproductlistdetails/:id',
        component: OptimizedProductlistdetailsPage,
    },
    {
        title: 'Material Types',
        path: '/material-types',
        component: MaterialTypesSettingsOverviewPage,
    },
    {
        title: 'Material Type',
        path: '/material-types/:id',
        component: MaterialTypesSettingsDetailPage,
    },
    {
        title: 'Producttypegroepen',
        path: '/product-type-groups',
        component: ProductTypeGroupsPage,
    },
    {
        title: 'Flows en statussen',
        path: '/flows-and-statuses',
        component: InteractiveProductFlowsPage,
    },
];
